import { instanceConexao } from "services/axiosServices";
import { AxiosRequestConfig } from "axios";

export const putEmpreendimentoRevendaStatus = async ({
  status,
  id,
  authToken,
}: {
  status: boolean;
  id: string;
  authToken: string;
}): Promise<any> => {
  const url = "/api/RevendaEmpreendimento/AtualizarStatus";
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };
  const response = await instanceConexao.put(url, { status, id }, config);
  return response?.data;
};
